<template>
    <component
        :is="component"
        v-if="component"
        :page="page"
        :mode="component"
    />
</template>

<script>
import { api } from "@@/services/ladder";
import AttributionBrand from "@/pages/attribution/AttributionBrand";
import AttributionClub from "@/pages/attribution/AttributionClub";
import CoachLayout from "@/pages/coach/CoachLayout";

const templateComponents = {
    1: "coach-layout", // coach
    2: "attribution-brand", // brand
    3: "attribution-club" // club
};

export default {
    name: "AttributionLayout",
    components: {
        AttributionBrand,
        AttributionClub,
        CoachLayout
    },
    props: {
        username: { required: true, type: String }
    },
    data() {
        return {
            page: null,
            component: null
        };
    },
    async created() {
        // Load the page data from api
        try {
            let page = await api.read(`pages/${this.username}`);

            // Silently make sure case is correct (i.e. switch /jhills to /JHills)
            if (this.username != page.username) {
                history.replaceState(
                    history.state,
                    document.title,
                    "/" + page.username
                );
            }

            this.page = page;
            // Use the template provided and default to coach (until it's in production)
            this.component = page.template
                ? templateComponents[page.template]
                : templateComponents[1];
        } catch (e) {
            // If there is an error fetching the page redirect to the homepage
            this.$router.replace("/");
        }
    }
};
</script>
